import { useEffect, useState } from "react";
import { type Conversation, aiApi } from "../lib/ai";
import { ChatPanel } from "../components/ai/ChatPanel";

export function Asistent() {
  const [conversations, setConversations] = useState<Conversation[]>([]);
  const [activeId, setActiveId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    aiApi
      .list()
      .then((list) => {
        if (!alive) return;
        setConversations(list);
        if (list.length && !activeId) setActiveId(list[0].id);
      })
      .catch(() => {})
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  async function newConversation() {
    setActiveId(null);
  }

  async function refreshList() {
    const list = await aiApi.list();
    setConversations(list);
  }

  async function remove(id: string) {
    if (!confirm("Ștergi conversația?")) return;
    await aiApi.delete(id);
    if (activeId === id) setActiveId(null);
    refreshList();
  }

  function onConversationChange(id: string) {
    setActiveId(id);
    refreshList();
  }

  return (
    <div className="asistent-page">
      <aside className="asistent-sidebar">
        <div className="asistent-sidebar-header">
          <h2>Conversații</h2>
          <button className="btn btn-primary btn-small" onClick={newConversation}>
            <i className="fa-solid fa-plus" /> Nouă
          </button>
        </div>
        <div className="asistent-conv-list">
          {loading && <div className="muted small">Se încarcă…</div>}
          {!loading && conversations.length === 0 && (
            <div className="muted small">Nicio conversație încă.</div>
          )}
          {conversations.map((c) => (
            <div
              key={c.id}
              className={`asistent-conv-item ${c.id === activeId ? "is-active" : ""}`}
              onClick={() => setActiveId(c.id)}
            >
              <span className="asistent-conv-title">{c.title}</span>
              <button
                className="asistent-conv-delete"
                onClick={(e) => {
                  e.stopPropagation();
                  remove(c.id);
                }}
                title="Șterge"
              >
                <i className="fa-solid fa-trash" />
              </button>
            </div>
          ))}
        </div>
      </aside>
      <main className="asistent-main">
        <ChatPanel
          key={activeId || "new"}
          conversationId={activeId}
          onConversationChange={onConversationChange}
          variant="page"
        />
      </main>
    </div>
  );
}
